import React from 'react';
import './Loading.css';

const Loading = ({ label = '' }) => (
  <div>
    <div className="loading-circle" />
    {label !== '' && <div className="loading-label">{label}</div>}
  </div>
);

export default Loading;
